import React from 'react'
import { FiAlignLeft } from "react-icons/fi";

export default function Header({children}) {
    const style = {
        display: 'flex',
        width: '100%',
        height: '60px',
        background: '#d50320',
        color: '#fff',
        justifyContent: 'center', alignItems: 'center'
    }
    const hStyle = {
        flex: 1,
        margin: 0,
        textAlign: 'center',
        fontWeight: 'bold',
        letterSpacing: '2px'
    }
    return (
        <div style={style}>
            {children}
        </div>
    )
}
